import React, { createContext, useState, useCallback } from 'react';
import {
  SuperAdminInfo,
  loginSuperAdmin,
  setAdminTokens,
  clearAdminTokens,
  getAdminToken,
} from '../services/adminService';

interface AdminAuthContextType {
  admin: SuperAdminInfo | null;
  token: string | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

export const AdminAuthContext = createContext<AdminAuthContextType>({
  admin: null,
  token: null,
  login: async () => {},
  logout: () => {},
});

export const AdminAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [admin, setAdmin] = useState<SuperAdminInfo | null>(null);
  const [token, setToken] = useState<string | null>(getAdminToken);

  const login = useCallback(async (email: string, password: string) => {
    const response = await loginSuperAdmin(email, password);
    setAdminTokens(response.token, response.refreshToken);
    setAdmin(response.usuario);
    setToken(response.token);
  }, []);

  const logout = useCallback(() => {
    clearAdminTokens();
    setAdmin(null);
    setToken(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ admin, token, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};
